let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "500",
        // trackFullPrice: '500',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1673604889642x360408613060083700',
        // earlyBird: true,
    },
    {
        trackTitle: "Junior Track",
        trackJunior: true,
        trackSubtitle: "For Junior specialists",
        trackPrice: "0",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1673604825930x165995226557054980',
        earlyBird: true,
    },
    {
        trackTitle: "2 Software Development Events",
        event1: "Typescript Global Summit'23",
        event2: "JavaScript Global Summit'23",
        event2Link: "https://events.geekle.us/js23/",
        trackPrice: "399",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: '2 Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1682943520925x891885874890932200',
    },
    {
        trackTitle: "Year of Typescript",
        year: "One year program with Four Full Access Tickets on 4 Typescript conferences",
        trackPrice: "499",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1683107721222x367245247658590200',
    },
];

export default PackagesItem;
